import React, { useState, useEffect } from 'react';
import Footer from '../components/footer';
import Header from '../components/header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { backendUrl } from '../utils/variables';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.clowza.app';

function isAndroidDevice() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
  const host = (window.location.hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host === '::1') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  const platform = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '';
  if (/Win/i.test(platform) || /Windows/i.test(ua)) return false;
  return /android/i.test(ua) || /android/i.test(platform);
}

export default function MobileAppPage() {
  const [currentVersion, setCurrentVersion] = useState(null);
  const [versionLoading, setVersionLoading] = useState(true);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    setIsAndroid(isAndroidDevice());
  }, []);

  useEffect(() => {
    fetch(`${backendUrl}/check_version.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ app_version: '0.0.0', platform: 'android' })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.current_version) {
          setCurrentVersion(data.current_version);
        }
      })
      .catch(() => {})
      .finally(() => setVersionLoading(false));
  }, []);

  if (isAndroid) {
    return (
      <div className="container">
        <Header />
        <div className="container-fluid mt-5 pt-3">
          <div className="row">
            <div className="col-md-12 col-sm-12 border p-4 text-center">
              <FontAwesomeIcon icon={faMobileAlt} className="text-primary" style={{ fontSize: '3rem' }} />
              <h2 className="mt-3 mb-2">Opening Google Play…</h2>
              <p className="text-muted mb-4">
                If nothing happens, tap the button below to get Clowza on Google Play.
              </p>
              <a
                href={PLAY_STORE_URL}
                className="btn btn-primary btn-lg"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                Download Android App
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="container">
      <Header />
      <div className="container-fluid mt-5 pt-3">
        <div className="row">
          <div className="col-md-12 col-sm-12 border p-4">
            <section className="py-4 mb-5">
              <div className="text-center mb-4">
                <FontAwesomeIcon icon={faMobileAlt} className="text-primary" style={{ fontSize: '3rem' }} />
                <h2 className="mt-3 mb-2">Clowza Mobile App</h2>
                <p className="text-muted">Get Clowza on Android from Google Play.</p>
                {!versionLoading && currentVersion && (
                  <p className="small text-muted">Current version: <strong>{currentVersion}</strong></p>
                )}
              </div>

              <div className="text-center">
                <a
                  href={PLAY_STORE_URL}
                  className="btn btn-primary btn-lg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                  Download Android App
                </a>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
